const Component = () => import('./Produce');

export { Component };
